import React from 'react'

const Banner = () => (
  <section id="banner" className="major">
    <div className="inner">
      <header className="major">
        <h1>Hi, my name is 王晓博(Shawb Wong).</h1>
      </header>
      <div className="content">
        <p>
          那些没写出来的想法
          <span role="img" aria-label="book">
            📒
          </span>
          , 我发现我已经忘了
          <span role="img" aria-label="think">
            🤔
          </span>
          <br />
          如果这个博客好久不更新了,说明我更浑浑噩噩了
        </p>
        <ul className="actions">
          <li>
            <a href="#one" className="button next scrolly">
              Get Started
            </a>
          </li>
        </ul>
      </div>
    </div>
  </section>
)

export default Banner
